import { render, staticRenderFns } from "./PageMonitoring.vue?vue&type=template&id=4a63d3bc&scoped=true"
import script from "./PageMonitoring.vue?vue&type=script&lang=js"
export * from "./PageMonitoring.vue?vue&type=script&lang=js"
import style0 from "./PageMonitoring.vue?vue&type=style&index=0&id=4a63d3bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a63d3bc",
  null
  
)

export default component.exports